import { Link } from "react-router-dom";
import { Map as MapIcon, ArrowRight } from "lucide-react";

export const LiveMapButton = ({ to = "/map", label = "Open Live Map", size = "md", testId = "live-map-button", showArrow = false }) => {
  const sizes = {
    sm: "text-xs px-4 py-2",
    md: "text-sm px-5 py-2.5",
    lg: "text-sm px-6 py-3.5",
  };
  return (
    <Link
      to={to}
      data-testid={testId}
      className={`live-map-btn relative inline-flex items-center gap-2 bg-[#2ec4b6] text-black font-heading font-semibold rounded-full hover:bg-[#3dd8ca] transition-colors shrink-0 whitespace-nowrap ${sizes[size] || sizes.md}`}
    >
      <span className="live-map-dot relative flex h-2 w-2">
        <span className="absolute inline-flex h-full w-full rounded-full bg-black/60 opacity-75 animate-ping" />
        <span className="relative inline-flex rounded-full h-2 w-2 bg-black" />
      </span>
      <MapIcon size={size === "lg" ? 16 : 15} /> {label}
      {showArrow && <ArrowRight size={15} />}
    </Link>
  );
};
